"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var getBlobFromURL_1 = __importDefault(require("./getBlobFromURL"));

var embedResources_1 = __importDefault(require("./embedResources"));

function embedBackground(clonedNode, options) {
  var background = clonedNode.style.getPropertyValue('background');

  if (!background) {
    return Promise.resolve(clonedNode);
  }

  return Promise.resolve(background).then(function (cssString) {
    return embedResources_1["default"](cssString, null, options);
  }).then(function (cssString) {
    clonedNode.style.setProperty('background', cssString, clonedNode.style.getPropertyPriority('background'));
    return clonedNode;
  });
}

function embedImageNode(clonedNode, options) {
  if (!(clonedNode instanceof HTMLImageElement) || utils_1.isDataUrl(clonedNode.src)) {
    return Promise.resolve(clonedNode);
  }

  return Promise.resolve(clonedNode.src).then(function (url) {
    return getBlobFromURL_1["default"](url, options);
  }).then(function (data) {
    return utils_1.toDataURL(data, utils_1.getMimeType(clonedNode.src));
  }).then(function (dataURL) {
    return new Promise(function (resolve, reject) {
      clonedNode.onload = resolve;
      clonedNode.onerror = reject;
      clonedNode.src = dataURL;
    });
  }).then(function () {
    return clonedNode;
  }, function () {
    return clonedNode;
  });
}

function embedChildren(clonedNode, options) {
  var children = utils_1.toArray(clonedNode.childNodes);
  var deferreds = children.map(function (child) {
    return embedImages(child, options);
  });
  return Promise.all(deferreds).then(function () {
    return clonedNode;
  });
}

function embedImages(clonedNode, options) {
  if (!(clonedNode instanceof Element)) {
    return Promise.resolve(clonedNode);
  }

  return Promise.resolve(clonedNode).then(function (node) {
    return embedBackground(node, options);
  }).then(function (node) {
    return embedImageNode(node, options);
  }).then(function (node) {
    return embedChildren(node, options);
  });
}

exports["default"] = embedImages;